import { gql } from '@parkchirp/api-client';

export const LIST_ZONES = gql`
  query listZones(
    $order: SortOrder
    $filters: [Filter]
    $limit: Int!
    $offset: Int!
    $category: String
  ) {
    listZones(
      order: $order
      filters: $filters
      limit: $limit
      offset: $offset
      category: $category
    ) {
      data {
        id
        name
        number
        facilityName
        facilityNumber
        hasActiveRateStructure
        cityName
        domainHourly
        organizationName
      }
      total
    }
  }
`;

export const GET_ZONE = gql`
  query getZone($zoneId: String!, $category: [String]) {
    getZone(zoneId: $zoneId, category: $category) {
      id
      name
      number
      facilityName
      facilityNumber
      facilityId
      organizationId
      cityId
      cityName
      cityState
      hourlyZoneQRCodeId
      zoneFees {
        id
        feeId
        fee {
          id
          feeName
          active
          calculationType
          feesHistory {
            id
            price
            startDate
            inactiveDate
            tax1
            tax2
            tax3
            tax4
            taxCalculation
            inputType
            productCode { id }
            rateCode { id }
            taxTableTax1 {
              id
              name
              taxNumber
              taxTableRates {
                percentageOfNet
                effectiveDate
              }
            }
            taxTableTax2 {
              id
              name
              taxNumber
              taxTableRates {
                percentageOfNet
                effectiveDate
              }
            }
            taxTableTax3 {
              id
              name
              taxNumber
              taxTableRates {
                percentageOfNet
                effectiveDate
              }
            }
            taxTableTax4 {
              id
              name
              taxNumber
              taxTableRates {
                percentageOfNet
                effectiveDate
              }
            }
          }
          hourlyFee {
            id
          }
        }
      }
      zoneSettings {
        id
        maxDuration
        scanToPayDurationIncrement
        messageWebCheckout
        messageWebActiveSession
        messageSMSConfirmation
        messageSMSExpiration
      }
      redemptionInstructions {
        source
        facilityConfigured
        facilitySelectedId
        facilitySteps
        selectedId
        name
        steps
        defaults {
          id
          name
          steps
        }
      }
      directions {
        source
        address
        text
        mapPinAddresses
      }
	  reservationOverrides {
		facilityAmenities
		amenities
		amenitiesOverridden
		facilityOperatingHours
		operatingHours
		operatingHoursOverridden
		facilityHeightRestriction
		heightRestriction
		heightRestrictionOverridden
		heightRestrictionEnabled
		facilityReservationThingsYouShouldKnow
		reservationThingsYouShouldKnow
		reservationThingsYouShouldKnowOverridden
		facilityMonthlyThingsYouShouldKnow
		monthlyThingsYouShouldKnow
		monthlyThingsYouShouldKnowOverridden
		facilityInOutPrivilegesAllowed
		inOutPrivilegesAllowed
		inOutPrivilegesAllowedOverridden
	  }
    }
  }
`;
